import api from "../../index";

export const GetAllibApi = (params) => api.get(`IBMaster/MyIBTeam-RequestListById?${params}`);
export const GetAllIBByIdApi = (IBId) => api.get(`Admin/GetSingleIBUser/${IBId}`);
export const GetCommissionAssignTreeApi = (userId, params) => api.get(`IBMaster/IBCommission-AssignTree/${userId}?${params}`);

export const GetAllAccountTypeApi = (params) => api.get(`DropDown/GetAll-AccountType?${params}`);
export const IBRejectApproveApi = (data) => api.post('Admin/IB/Approve-Reject', data);


export const getUnassignAccountTypeApi = (userId, planId) => api.get(`Admin/IB/UnAssign-temp-IBplan/${userId}?PageSize=100${planId ? `&planId=${planId}` : ''}`);
export const getUnassignApprovedAccountTypeApi = (userId, planId) => api.get(`PlanAccountType/Get-UnAssigned-IBPlan/${userId}?PageSize=100${planId ? `&planId=${planId}` : ''}`);
export const SaveTempPlanApi = (data) => api.post('Admin/IB/save-temp-plan', data);

export const GetPlanListApi = (userId) => api.get(`Admin/IB/AccountTypeConfig/GetPending?userId=${userId}`);
export const GetActiveIbPlanList = (userId) => api.get(`PlanAccountType/Get-Assigned-IBPlan/${userId}`)

export const ApproveIbRequestApi = (data) => api.post(`Admin/IB/Approve-Reject`, data);
export const DeleteTempPlanApi = (data) => api.delete(`Admin/IB/delete-temp-plan`, { data, headers: { 'Content-Type': 'application/json' } });

export const UpdateIbRequestApi = (data) => api.put(`IBMaster/Update-Plan-For-IB-User`, data);
export const AddPlanToIBUserApi = (data) => api.post(`IBMaster/Assign-New-Plan-To-IB-User`, data);

export const DeletePlanForIBUserApi = (data) => api.delete('IBMaster/Delete-Plan-For-IB-User', { data, headers: { 'Content-Type': 'application/json' } });
